// @flow
import { ArrowRight, User } from 'lucide-react';

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useLoginCallbackUrl } from 'src/modules/config';

import styles from './LoginBlock.scss';

export function LoginBlock(): React.MixedElement {
  const { __ } = useTranslator();

  const href = useLoginCallbackUrl();

  return (
    <div className={styles.root}>
      <span>
        <span className={styles.iconContainer}>
          <User size={16} />
        </span>
        {__('You must be logged in to access advanced search')}
      </span>
      <Button href={href}>
        {__('Log in')} <ArrowRight size={20} />
      </Button>
    </div>
  );
}
